import React, { useState, useEffect, Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { StickyTable, Row as StickyRow, Cell } from 'react-sticky-table';
import { Scrollbars } from 'react-custom-scrollbars';
import { NavLink } from 'react-router-dom';

// component
import { Text, Button } from 'Component/Ajaib';
import { onDoRequestMutualFund } from 'Redux/mutualFund';
import { onDoRequestCategoryDiscoveryFund } from 'Redux/mfDiscovery';
import { onDoRequestConfig } from 'Redux/config';

import { useLoginPin } from '@hooks/auth';
import { useUserData } from '@services/users/me';

// style
import styles from './style';

// asset
import DashboardMutualFundContent from './Content';

let showCategory = '';

const DashboardMutualFund = () => {
  const dispatch = useDispatch();

  const { userData } = useUserData();
  const { isUserNotOnThePinScreen } = useLoginPin();

  const [activeFilter, setActiveFilter] = useState('terpopuler');

  const categoryData = useSelector((state) => state.mfDiscovery.discoveryCategoryFundData);
  const categoryLoading = useSelector((state) => state.mfDiscovery.discoveryCategoryFundLoading);
  const configData = useSelector((state) => state.config.configData);

  useEffect(() => {
    if (!userData || !userData.user_info) return;
    if (!isUserNotOnThePinScreen) return;

    const hasCategoryData = Array.isArray(categoryData) && categoryData.length > 0;

    if (!hasCategoryData && !categoryLoading) {
      dispatch(onDoRequestCategoryDiscoveryFund());
    }

    dispatch(onDoRequestConfig());
  }, [userData, isUserNotOnThePinScreen, categoryData, categoryLoading]);

  useEffect(() => {
    setActiveFilter(categoryData && categoryData[0].name);
    showCategory = categoryData && categoryData.slice(0, 4);
  }, [categoryData]);

  const findFilter = showCategory && showCategory.find((b) => b.name === activeFilter);

  useEffect(() => {
    if (!findFilter) return;
    const categoryId = findFilter.id;
    const payload = {
      category_id: categoryId,
      page: 1,
      page_size: 20,
    };
    dispatch(onDoRequestMutualFund(payload, categoryId));
  }, [activeFilter]);

  const headerContents = [
    { text: 'Nama Reksa Dana ', className: 'table-header' },
    { text: 'Return', type: 'number', className: 'table-header text-right' },
  ];

  return (
    <>
      <Row>
        <Col className="d-flex justify-content-between align-items-center">
          <div>
            <Text size="section" bold>
              Reksa Dana Pilihan
            </Text>
          </div>
          <div>
            <NavLink end to="/home/mutual-funds">
              <Button variant="sentence" size="sm">
                Selengkapnya
              </Button>
            </NavLink>
          </div>
        </Col>
      </Row>
      <Row className="mt-16">
        <Col>
          {showCategory &&
            showCategory.map((btn) => (
              <Button
                variant="tab"
                key={btn.name}
                active={activeFilter === btn.name}
                data-key={btn.name}
                onClick={() => {
                  setActiveFilter(btn.name);
                }}
                className="mr-8"
              >
                {btn.name}
              </Button>
            ))}
        </Col>
      </Row>
      <Row className="mt-16">
        <Col>
          <Scrollbars style={styles.dataContainer} autoHide className="table-shadow">
            <StickyTable stickyHeaderCount={1} className="use-custom-scrollbars">
              <StickyRow>
                {headerContents.map((c) => (
                  <Cell className={c.className} key={c.text}>
                    <Text size="table-header-regular">
                      {c.text === 'Return'
                        ? `${c.text} ${
                            configData
                              ? configData.mf_return_show
                                ? configData.mf_return_show
                                : '1Y'
                              : '1Y'
                          }`
                        : c.text}
                    </Text>
                  </Cell>
                ))}
              </StickyRow>
              <DashboardMutualFundContent
                categoryId={findFilter && findFilter.id.toString()}
                returnConfig={configData && configData.mf_return_show}
              />
            </StickyTable>
          </Scrollbars>
        </Col>
      </Row>
    </>
  );
};

export default DashboardMutualFund;
